import { AppConstants } from "../../app-constants";
import { StandardRating } from "../../services/accreditation.service";

export class AccreditationResponse {
  instructions: string;
  expectations: string;
  projectPermissions: any;
  submitPermissions: boolean;
  name: string;
  standard: Standard;
  userAccessRights : {allowView: boolean, allowComment: boolean, allowEdit: boolean, editFeedback: boolean, readIfProgramSubmitted: boolean};
  isCurrent: boolean;
  lockedForFinalFeedback: boolean;
  status: ProjectStatus;
  requestKey: string;
  narrativeWordCount: number;
  preliminaryFeedbackState: feedbackState;
  evaluatorRating: StandardRating;
  projectRequestKey: string;

  constructor(
    requestKey: string = "",
    instructions: string = "",
    expectations: string = "",
    projectPermissions: any = null,
    submitPermissions: boolean = true,
    name: string = "",
    standard: Standard = null,
    userAccessRights: { allowView: boolean, allowComment: boolean, allowEdit: boolean, editFeedback: boolean, readIfProgramSubmitted: boolean } = {allowView: true, allowComment: false, allowEdit: false, editFeedback: false, readIfProgramSubmitted: false},
    isCurrent: boolean = false,
    lockedForFinalFeedback: boolean = true,
    statusRequestKey: string = "",
    narrativeWordCount: number = 0,
    preliminaryFeedbackState: number = 0,
    evaluatorRating: StandardRating = null,
    projectRequestKey: string = "",
  ) {
    this.requestKey = requestKey;
    this.instructions = instructions;
    this.expectations = expectations;
    this.projectPermissions = projectPermissions;
    this.submitPermissions = submitPermissions;
    this.name = name;
    this.standard = standard;
    this.userAccessRights = userAccessRights;
    this.isCurrent = isCurrent;
    this.lockedForFinalFeedback = lockedForFinalFeedback;
    this.status = this.getProjectStatus(statusRequestKey);
    this.narrativeWordCount = narrativeWordCount;
    this.preliminaryFeedbackState = preliminaryFeedbackState;
    this.evaluatorRating = evaluatorRating;
    this.projectRequestKey = projectRequestKey;
  }

  getProjectStatus(statusRequestKey): ProjectStatus {
    switch ( statusRequestKey ) {
      case AppConstants.accreditationStandardStatuses.submitted.guid:
        return AppConstants.accreditationStandardStatuses.submitted;
        break;
      case AppConstants.accreditationStandardStatuses.notStarted.guid:
        return AppConstants.accreditationStandardStatuses.notStarted;
        break;
      case AppConstants.accreditationStandardStatuses.internalReview.guid:
        return AppConstants.accreditationStandardStatuses.internalReview;
        break;
      case AppConstants.accreditationStandardStatuses.readyForSubmission.guid:
        return AppConstants.accreditationStandardStatuses.readyForSubmission;
        break;
      case AppConstants.accreditationStandardStatuses.inProgress.guid:
        return AppConstants.accreditationStandardStatuses.inProgress;
        break;
      default:
        return AppConstants.accreditationStandardStatuses.inProgress;
        break;
    }
  }

  getProjectStatusForSave(statusRequestKey): ProjectStatus {
    switch ( statusRequestKey ) {
      case AppConstants.accreditationStandardStatuses.notStarted.guid:
        return AppConstants.accreditationStandardStatuses.notStarted;
        break;
      case AppConstants.accreditationStandardStatuses.inProgress.guid:
        return AppConstants.accreditationStandardStatuses.inProgress;
        break;
      case AppConstants.accreditationStandardStatuses.internalReview.guid:
        return AppConstants.accreditationStandardStatuses.internalReview;
        break;
      case AppConstants.accreditationStandardStatuses.submitted.guid:
      case AppConstants.accreditationStandardStatuses.readyForSubmission.guid:
        return AppConstants.accreditationStandardStatuses.readyForSubmission;
        break;
      default:
        return AppConstants.accreditationStandardStatuses.inProgress;
        break;
    }
  }

}

export interface Standard{
  name: string,
  description: string,
  accreditor: {
    isAccreditorOnline: boolean,
    name: string
  },
  standardGroup: any
}
export interface ProjectStatus {
  name:string,
  guid: string,
  class:string
}
export enum feedbackState {
  'No feedback' = 1,
  'Requested',
  'Responded',
  'Read'
}
